import { Grid, Space, Table } from "../components/Layout";
import { Title, Texts, Media } from "../components/Object";
import { NewsList, Pagination } from "../components/Post";
import { Head } from "../components/Project";
import { useParams } from "react-router-dom";

const News = () => {
  const gridProps = {
    list: {
      gap: ["64px", "24px"],
      layout: ["repeat(3, 1fr)", "100%"],
      size: "100%",
    },
  };

  const parms = useParams();

  const args = {
    page: parms.id ? parms.id : 1,
    type: "posts",
    perPage: 12,
  };

  return (
    <>
      <Head type="noimage" slug="posts"></Head>
      <div className="l-row">
        <NewsList
          noimage={true}
          perPage={args.perPage}
          page={args.page}
        ></NewsList>

        <Pagination
          page={args.page}
          postType={args.type}
          perPage={args.perPage}
        ></Pagination>
      </div>

      <Space size={["200px", "120px"]}></Space>
    </>
  );
};

export default News;